const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const buildQueryParams = (paramsObj) => {
    return Object.entries(paramsObj)
        .filter(([_, value]) => value !== null && value !== undefined && value !== '')
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
};

const handleError = async (response, fallbackMessage = "حدث خطأ غير متوقع") => {
    let message = fallbackMessage;
    try {
        const data = await response.json();
        message = data?.message || data?.error || fallbackMessage;
    } catch (_) {
        try {
            const text = await response.text();
            message = text || fallbackMessage;
        } catch (_) { }
    }

    console.error(`API Error [${response.status}]: ${message}`);
    throw new Error(message);
};

export const getAverageWaitingTime = async (filters) => {
    const params = buildQueryParams(filters);
    const response = await fetch(`${BASE_URL}/stats/queue-metrics/avg-waiting-time?${params}`);
    if (!response.ok) {
        await handleError(response, "حدث خطأ أثناء تحميل وقت الانتظار");
    }
    const data = await response.json();
    return data || {};
};

export const getAverageServicePeriod = async (filters) => {
    const params = buildQueryParams(filters);
    const response = await fetch(`${BASE_URL}/stats/queue-metrics/avg-service-period?${params}`);
    if (!response.ok) {
        await handleError(response, "حدث خطأ أثناء تحميل مدة الخدمة");
    }
    return await response.json();
};

export const getMaxWaitingTime = async (filters) => {
    const params = buildQueryParams(filters);
    const response = await fetch(`${BASE_URL}/stats/queue-metrics/max-waiting-time?${params}`);
    if (!response.ok) {
        await handleError(response, "حدث خطأ أثناء تحميل الحد الأقصى لوقت الانتظار");
    }
    return await response.json();
};

export const getDailyReservations = async (filters) => {
    const params = buildQueryParams(filters);
    const response = await fetch(`${BASE_URL}/stats/queue-metrics/daily-reservations?${params}`);
    if (!response.ok) {
        await handleError(response, "حدث خطأ أثناء تحميل عدد الحجوزات اليومية");
    }
    return await response.json();
};

export const getCongestionTimes = async (filters) => {
    const params = buildQueryParams(filters);
    const response = await fetch(`${BASE_URL}/stats/queue-metrics/congestion-times?${params}`);
    if (!response.ok) {
        await handleError(response, "حدث خطأ أثناء تحميل أوقات الذروة");
    }
    return await response.json();
};

export const getServiceUsage = async (filters) => {
    const params = buildQueryParams(filters);
    const response = await fetch(`${BASE_URL}/stats/queue-metrics/service-usage?${params}`);
    if (!response.ok) {
        await handleError(response, "حدث خطأ أثناء تحميل بيانات استخدام الخدمة");
    }
    return await response.json();
};

export const getServiceRate = async (filters) => {
    const params = buildQueryParams(filters);
    const response = await fetch(`${BASE_URL}/stats/queue-metrics/service-rate?${params}`);
    if (!response.ok) {
        await handleError(response, "حدث خطأ أثناء تحميل تقييم الخدمة");
    }
    return await response.json();
};
